import {
  ArticleHeading2,
  ArticleHeading3,
  ArticleParagraph1,
  ArticleParagraph2,
  Responsive,
  useDeviceType,
} from '@cian/ui-kit';
import * as style from './styles.css';
import { clsx } from 'clsx';
import { IUtpItemWithImage } from 'shared/types/utp';

type TCatsBenefitsProps = IUtpItemWithImage;

export const Benefits: React.FC<TCatsBenefitsProps> = ({ title, descr, imageClass }) => {
  const device = useDeviceType();

  const isPhone = device === 'phone';

  const Title = isPhone ? ArticleHeading3 : ArticleHeading2;

  const Description = isPhone ? ArticleParagraph2 : ArticleParagraph1;

  return (
    <div className={clsx(style['item'], style[device])}>
      <Responsive desktop>
        <div className={clsx(style['item-image'], style[imageClass])} />
      </Responsive>
      <div className={style['item-title']}>
        <Title color="primary_100">{title}</Title>
      </div>
      <div className={style['item-descr']}>
        <Description textAlign="center">{descr}</Description>
      </div>
      <Responsive phone tablet>
        <div className={clsx(style['item-image'], style[imageClass])} />
      </Responsive>
    </div>
  );
};
